import { cn } from '@/shared/lib/cn';

function creditsTone(percentUsed: number, exhausted?: boolean): 'ok' | 'warning' | 'danger' {
  if (exhausted || percentUsed >= 100) return 'danger';
  if (percentUsed >= 80) return 'warning';
  return 'ok';
}

/** Barra de consumo 0–100%. É tudo que o usuário comum vê dos créditos. */
export function CreditsBar({
  percentUsed,
  exhausted,
  className,
  showLabel = true,
}: {
  percentUsed: number;
  exhausted?: boolean;
  className?: string;
  showLabel?: boolean;
}) {
  const percent = Math.min(100, Math.max(0, Math.round(percentUsed)));
  const tone = creditsTone(percent, exhausted);

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-label="Créditos de IA usados"
        className="h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-muted-foreground/15"
      >
        <div
          className={cn(
            'h-full rounded-full transition-[width] duration-500',
            tone === 'danger' ? 'bg-destructive' : tone === 'warning' ? 'bg-warning' : 'bg-primary',
          )}
          style={{ width: `${percent}%` }}
        />
      </div>
      {showLabel ? (
        <span
          className={cn(
            'shrink-0 text-xs tabular-nums',
            tone === 'danger' ? 'text-destructive' : tone === 'warning' ? 'text-warning' : 'text-muted-foreground',
          )}
        >
          {percent}%
        </span>
      ) : null}
    </div>
  );
}
